export const DotsLoader = () => {
    return (
        <span className="w-3 h-3 rounded-full inline-block relative text-support-purple-100 animate-loader-dots">
            {" "}
        </span>
    );
}

